/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { infoDisplayStylesTwo } from "@eisinc/App/SharedStyles/InfoDisplayStyles";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { InvoiceDetailsPageContext } from "@insite/content-library/Pages/InvoiceDetailsPage";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { useContext } from "react";

const styles = infoDisplayStylesTwo;

const InvoiceDetailsNotes: React.FunctionComponent = () => {
    const { value: invoice } = useContext(InvoiceStateContext);

    if (!invoice || !invoice.notes) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate("Notes")}</Typography>
            <Typography>{invoice.notes}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceDetailsNotes,
    definition: {
        allowedContexts: [InvoiceDetailsPageContext],
        group: "Invoice History",
    },
};

export default widgetModule;
